export function isSafeRedirect(url: string): boolean {
  return /^\/[a-zA-Z0-9_-]/.test(url);
}
